import { useCallback, useState } from 'react'

const STORAGE_KEYS = {
  user: 'proffer-sidebar-collapsed',
  admin: 'proffer-admin-sidebar-collapsed',
} as const

export type SidebarScope = keyof typeof STORAGE_KEYS

function loadCollapsed(scope: SidebarScope): boolean {
  try {
    return localStorage.getItem(STORAGE_KEYS[scope]) === '1'
  } catch {
    return false
  }
}

export const SIDEBAR_WIDTH_EXPANDED = '17.5rem'
export const SIDEBAR_WIDTH_COLLAPSED = '4.5rem'

export function useSidebarCollapsed(scope: SidebarScope) {
  const [collapsed, setCollapsedState] = useState(() => loadCollapsed(scope))

  const setCollapsed = useCallback(
    (next: boolean) => {
      setCollapsedState(next)
      try {
        localStorage.setItem(STORAGE_KEYS[scope], next ? '1' : '0')
      } catch {
        /* ignore */
      }
    },
    [scope],
  )

  const toggle = useCallback(() => {
    setCollapsedState((prev) => {
      const next = !prev
      try {
        localStorage.setItem(STORAGE_KEYS[scope], next ? '1' : '0')
      } catch {
        /* ignore */
      }
      return next
    })
  }, [scope])

  return { collapsed, setCollapsed, toggle, open: !collapsed }
}
